import types from '@/data/filters/types'
import causes from '@/data/filters/causes'
import subjects from '@/data/filters/subjects'
import locations from '@/data/filters/locations'
import tags from '@/data/filters/tags'
import created_by from '@/data/filters/createdBy'

export default {
    data: {
        getIssueFilterOptions: {
            types,
            causes,
            subjects,
            locations,
            tags,
            created_by,
        },
    },
}
